import { Inject, Injectable, Injector } from '@angular/core';
import { PlatformService } from './platform.service';
import { environment } from '@env/environment';
import { DOCUMENT } from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class DomainService {

  constructor(@Inject(DOCUMENT) private document,
    private injector: Injector,
    private platformService: PlatformService) {
    if (this.platformService.isPlatformServer) {
      console.log(this.injector.get('host'))
    } else {
      console.log('document: ', document.location.hostname);
    }
  }

  getFisrtSubdomain(): string {

    if (this.platformService.isPlatformServer) {
      const host = this.getHostName();
      const parts = host.split('.');

      for (let part of parts) {
        if (part !== 'www') {
          return part;
        }
      }
    }
    else
      if (this.platformService.isPlatformBrowser) {
        const host = window.location.hostname;
        const parts = host.split('.');

        for (let part of parts) {
          if (part !== 'www') {
            return part;
          }
        }
      }
    return '';
  }

  getHost() {
    return this.injector.get('host');
  }

  getHostName(): string {

    try {

      if (this.platformService.isPlatformServer) {
        return this.injector.get('host') || '';
      }

      if (this.platformService.isPlatformBrowser) {
        return window.location.hostname.replace(/^www\./, '') || ''
      }
    }
    catch { }

    return '';
  }

  isActiveSubdomainComplaint(): boolean {

    if (environment.production === true)
      return true;

    if (environment.beta === true)
      return true;

    return false;
  }

  isComplaintChannelDomain(): boolean {

    const hostName = this.getHostName();

    return hostName.endsWith(environment.relativePathComplaintChannel);
  }

  isWorkWithUsDomain(): boolean {

    const hostName = this.getHostName();
    console.log(hostName);

    if (hostName.endsWith(environment.relativePathComplaintChannel))
      return false;

    if (!hostName.endsWith(environment.basePathDomain))
      return false;

    if (hostName === environment.basePathDomain)
      return false;

    return true;
  }

  getDomain() {
    const hostName = this.getHostName();
    return hostName;
  }
}
